<template>
  <div
    id="serviceDetail"
    v-title
    :data-title="service.name ? service.name : ''"
  >
    <!-- 添加事前评价按钮 -->
    <a
      href="javascript:;"
      v-if="appraiseOn == 'true'"
      @click="btnRecodeClickHandler"
      class="recode-button"
      >评价</a
    >
    <template v-if="hasAuth">
      <div class="service-container">
        <!--   收藏   -->
        <b class="collect" @click.stop="onCollectHandle">
          <van-icon
            class="iconfont"
            class-prefix="icon"
            :name="collect ? 'collection-fill' : 'collection'"
          ></van-icon>
        </b>
        <h4>{{ service.name }}</h4>
        <h6 class="color999">
          事项编号:{{ service.code ? service.code : defaultValue }}
          <em></em>
          {{ service.bt ? service.bt : defaultValue }}次访问
        </h6>
        <p class="text-overflow">
          服务人群：{{ serviceExtends.roleName || defaultValue }}
        </p>
        <p class="text-overflow">
          服务权限：{{
            service && service.auth && service.auth.roleName
              ? service.auth.roleName
              : "不详"
          }}
        </p>
        <p class="text-overflow">所属部门：{{ service.deptName }}</p>
        <p>服务日期：{{ expiryDate }}</p>
        <p v-if="showExtends">
          办理地点：
          <van-icon name="location-o" color="#0000ff" />
          <span class="addressSpan" @click="showPopup">
            {{ extend.handleAddress }}
          </span>
        </p>

        <!--   button   -->
        <div
          :class="['service-btn-boxs']"
          v-if="onlineBtnShowNum > banliBtns.length"
        >
          <van-button
            :disabled="access(item)[1]"
            block
            v-for="(item, index) in banliBtns"
            :key="index"
            @click="btnClickHandler(item.blmurl, access(item)[1])"
          >
            {{ item.blname }}
          </van-button>
        </div>
        <div :class="['service-btn-box']" v-else>
          <van-button
            :disabled="access(item)[1]"
            block
            v-for="(item, index) in banliBtns"
            :key="index"
            @click="btnClickHandler(item.blmurl, access(item)[1])"
          >
            {{ item.blname }}
          </van-button>
        </div>
        <!--   控制button显示隐藏   -->
        <p
          :class="['toggle-icon', { close: btnBoxOpen }]"
          v-if="onlineBtnShowNum < arrLength"
        >
          <van-icon
            class="iconfont"
            class-prefix="icon"
            name="enterinto"
            @click.native="btnBoxOpen = !btnBoxOpen"
          ></van-icon>
        </p>
        <p
          :class="['toggle-icon', { close: btnBoxOpen }]"
          v-if="onlineBtnShowNum == arrLength"
        >
          <van-icon
            style="display: none"
            class="iconfont"
            class-prefix="icon"
            name="enterinto"
            @click.native="btnBoxOpen = !btnBoxOpen"
          ></van-icon>
        </p>
      </div>
      <template v-if="showExtends">
        <div class="base-info service-info">
          <h4>基本信息</h4>
          <p>办理方式：{{ serviceExtends.applyType || defaultValue }}</p>
          <p>事项性质：{{ serviceExtends.serviceType || defaultValue }}</p>
          <p>办理途径：{{ serviceExtends.entry || defaultValue }}</p>
          <p>办理时间：{{ serviceExtends.serviceRoutine || "-" }}</p>
          <p>咨询电话：{{ serviceExtends.contactNumber || defaultValue }}</p>
          <p>
            监督电话：{{ serviceExtends.supervisionNumber || defaultValue }}
          </p>
        </div>
        <div
          class="service-info"
          v-for="(item, index) in serviceExtends.extends"
          :key="index"
          v-image-preview
        >
          <h4>{{ item.name }}</h4>
          <img
            v-if="item.img && item.img.position == 'top'"
            :src="complete(item.img.url)"
          />
          <template v-if="item.type == 'text'">
            <template v-if="item.detail.length">
              <p
                v-for="(detailItem, detailIndex) in item.detail"
                :key="detailIndex"
              >
                {{ detailIndex + 1 }}：{{ detailItem.text }}

                <template
                  v-if="detailItem.detail && detailItem.detail.downloadUrl"
                >
                  <video
                    autoplay
                    controls
                    style="width: 100%; height: 30vh"
                    id="videojs-flvjs-player"
                    ref="videojs-flvjs-player"
                    class="video-js vjs-default-skin vjs-big-play-centered"
                    webkit-playsinline="“true”"
                    allowsInlineMediaPlayback="YES"
                    webview.allowsInlineMediaPlayback="YES"
                  >
                    <source
                      :src="
                        complete(
                          detailItem.detail && detailItem.detail.downloadUrl
                        )
                      "
                      type="video/mp4"
                    />
                  </video>
                </template>

                <!-- <div v-if="flvUrl">
                                    <video
                                        controls
                                        style="width: 100%; height: 30vh"
                                        id="videojs-flvjs-player"
                                        ref="videojs-flvjs-player"
                                        class="video-js vjs-default-skin vjs-big-play-centered"
                                    ></video>
                                </div> -->
              </p>
            </template>
          </template>
          <template v-if="item.type == 'attach'">
            <template v-if="item.detail.length">
              <p
                v-for="(detailItem, detailIndex) in item.detail"
                :key="detailIndex"
              >
                <span
                  v-if="detailItem.detail"
                  class="download-link"
                  @click="
                    onPreviewFile(
                      detailItem.detail.fileType,
                      detailItem.detail.downloadUrl
                    )
                  "
                >
                  <i
                    :class="[
                      'fileIcon',
                      detailItem.detail &&
                      detailItem.detail.fileType &&
                      fileIcons.indexOf(detailItem.detail.fileType) >= 0
                        ? detailItem.detail.fileType
                        : 'unknown',
                    ]"
                  ></i>
                  {{ detailIndex + 1 }}：{{ detailItem.text }}
                </span>
                <span v-else class="download-link" @click="downloadFail">
                  <i class="fileIcon unknown"></i>
                  {{ detailIndex + 1 }}、{{ detailItem.text }}
                </span>
              </p>
            </template>
          </template>
          <template v-if="item.type == 'table'">
            <template v-if="item.detail && item.detail.length > 0">
              <div
                class="about-dept"
                v-for="(deptItem, num) in item.detail"
                :key="num"
              >
                <p v-for="(subItem, idx) in item.header" :key="idx">
                  <label>{{ subItem.name }}：</label>
                  {{ deptItem[subItem.key] }}
                </p>
              </div>
            </template>
          </template>
          <img
            v-if="
              item.img && (item.img.position == 'bottom' || !item.img.position)
            "
            :src="complete(item.img.url)"
          />
        </div>
      </template>
      <div class="service-info">
        <h4>其他说明</h4>
<!--       text-rich  -->
        <div
          v-html="service.desc"
          class="panel-intro"
          v-image-preview
        ></div>
      </div>
      <div class="detail-tabbar" v-if="showTabbar">
        <div
          class="tabbar-item"
          v-if="showFeedback"
          @click="locationTo(service.service[0].blmurl)"
        >
          <div class="icon-box">
            <van-icon
              class="iconfont"
              class-prefix="icon"
              name="editor"
            ></van-icon>
          </div>
          <span>意见反馈</span>
        </div>
        <div
          class="tabbar-item"
          v-if="showOnlineConsult"
          @click="
            locationTo(
              `weixin/weui/quanzi.html#list/${service.quanziId}/quanzi`
            )
          "
        >
          <div class="icon-box">
            <van-icon
              class="iconfont"
              class-prefix="icon"
              name="message"
            ></van-icon>
          </div>
          <span>我要咨询</span>
        </div>
        <div
          class="tabbar-item"
          @click="locationTo(`weixin/weui/yuyue.html#yuyue/${id}`)"
        >
          <div class="icon-box">
            <van-icon
              class="iconfont"
              class-prefix="icon"
              name="time"
            ></van-icon>
          </div>
          <span>在线预约</span>
        </div>
      </div>
    </template>
    <Error :type="'forbidden'" v-else></Error>
    <van-action-sheet
      v-model="showPopupFlag"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="changMap"
    />
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import {
  queryServiceExtends,
  queryService,
  favService,
  cancelFavService,
  increaseHandle,
} from "@/api/service-hall";
import {
  previewFile,
  parseFileType,
  previewImage,
  FILE_TYPE_IMAGE,
} from "@/utils/file";
import { complete, locationTo, baseURL } from "@/utils/url";
import { forward } from "@/utils/serviceUtil";
import { formatDateTime } from "@/utils/dateTimeUtil";
import moment from "moment";
import http from "@/utils/http";
import { sysVariable } from "@/utils/sys-variable";
import wx from "weixin-js-sdk";
import '@/assets/js/ueditor.parse.js'

export default {
  name: "ServiceDetail",
  props: ["id"],
  data() {
    return {
      //button 是否展开
      appraiseOn: "",
      btnBoxOpen: false,
      showExtends: false,
      service: {},
      serviceExtends: {},
      defaultValue: "暂无",
      fileIcons: [
        "doc",
        "docx",
        "gif",
        "jpg",
        "pdf",
        "png",
        "ppt",
        "pptx",
        "rar",
        "txt",
        "xls",
        "xlsx",
        "zip",
      ],
      userId: "",
      roleName: "",
      parseExpiryDate: ["", "长期有效", "每日", "每月", "每年"],
      weekDate: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      hasAuth: true,
      isShowFeedbackAndOnlineConsult: {},
      onlineBtnShowNum: 0,
      arrLength: 0,
      flvUrl: "",
      showPopupFlag: false,
      actions: [
        //   { mapType: "qqmap", name: "腾讯地图" },
        { mapType: "amap", name: "高德地图" },
        { mapType: "baidumap", name: "百度地图" },
      ],
      extend: {
        // handleAddress: "内蒙古自治区呼和浩特市赛罕区宇泰商务广场C座1",
        // handleAddressJW: {
        //   Q: 40.779076,
        //   R: 111.710205,
        //   lat: 40.779076,
        //   lng: 111.710205,
        // },
      },
    };
  },
  computed: {
    collect() {
      return this.service.isf == "1";
    },
    showBanli() {
      // 是否显示在线办理
      // 无权限、未启用、已停用三种状态显示在页面上
      return this.service.service[2].blisuse === "true";
    },
    banliBtns() {
      if (this.service.service) {
        if (!this.btnBoxOpen) {
          let arr =
            this.service.service[2].blArr &&
            this.service.service[2].blArr.filter((item) => item.blmurl);
          return arr.slice(0, this.onlineBtnShowNum);
        } else {
          return (
            this.service.service[2].blArr &&
            this.service.service[2].blArr.filter((item) => item.blmurl)
          );
        }
      }
      return [];
    },
    // //是否显示按钮的展开收起
    // showBtnBoxOpen() {
    //     if(onlineBtnShowNum <= banliBtns.length) {
    //         if(onlineBtnShowNum < banliBtns.length) {
    //             return true
    //         } else {
    //             return false
    //         }
    //     } else {
    //         return false
    //     }
    // },
    visitorAuth() {
      // 是否有访客权限（当前用户为访客且服务为访客服务）
      return this.userId == "visitor" && this.service.isVisitor == "true";
    },
    showFeedback() {
      return (
        !this.visitorAuth && // 访客不显示
        this.hasAuth && // 判断权限
        this.isShowFeedbackAndOnlineConsult.feedBack == "true" && // 判断系统参数
        this.service.service[0].fkisuse == "true" && // 判断意见反馈是否开启
        this.service.service[0].blmurl
      ); // 判断意见反馈是否为空
    },
    showOnlineConsult() {
      return (
        !this.visitorAuth && // 访客不显示
        this.hasAuth && // 判断权限
        this.isShowFeedbackAndOnlineConsult.onlineConsult == "true" && // 判断系统参数
        this.service.service[1].zxisuse == "true"
      ); // 判断在线咨询是否开启
    },
    // showYuyue() {
    //     let arr = this.service
    //      if(arr.service) {
    //          console.log(arr.service[2].blArr.length);
    //          this.arrLength = arr.service[2].blArr.length
    //     }
    //      if (arr && arr.service) {
    //         return (
    //             !this.visitorAuth && // 访客不显示
    //            this.hasAuth && // 判断权限
    //              arr &&
    //              arr.service[3].yyisuse == "true"
    //         ) // 判断在线预约是否开启
    //      } else {
    //          return false
    //      }
    //  },
    showTabbar() {
      return this.showFeedback || this.showOnlineConsult;
    },
    expiryDate() {
      if (this.service.expiryDate == "5") {
        var week = this.service.weekend;
        var weekArr = week.split(",");
        //数组weekArr中的0对应this.weekDate中的周日，1对应周一，以此类推
        var weekStr = "";
        for (var i = 0; i < weekArr.length; i++) {
          weekStr += this.weekDate[weekArr[i]] + "、";
        }
        weekStr = weekStr.substring(0, weekStr.length - 1);
        var startTime = moment(this.service.weekendStartTime).format(
          "HH:mm:ss"
        );
        var endTime = moment(this.service.weekendEndTime).format("HH:mm:ss");
        var time = startTime + "至" + endTime;
        weekStr = weekStr + " " + "(" + time + ")";
        return weekStr;
      } else {
        return this.parseExpiryDate[parseInt(this.service.expiryDate)];
      }
    },
  },
  created() {


    this.getSys();
    // 2023-10-23 财大评价二开 系统参数中获取好差评开关及好差评Path
    sysVariable("appraiseOn").then((resp) => {
      this.appraiseOn = resp;
      //this.appraiseOn = 'true'
      console.log("---------appraiseOn----------");
      console.log(this.appraiseOn);
    });
    sysVariable("appraisePath").then((resp) => {
      this.appraisePath = resp;
    });
    this.mixinShowLoading();
    //请求服务详情页数据
    queryService(this.id)
      .then((resp) => {
        console.log(resp);
        if(resp.item.stats===0){
            Dialog.alert({message: '当前服务已停用！',})
            return;
          }
          if(resp.item.stats===2){
            Dialog.alert({message: resp.item.tips,})
            return;
          }
        this.canPraise = resp.canPraise;
        this.isShowFeedbackAndOnlineConsult =
          typeof resp.isShowFeedbackAndOnlineConsult === "string"
            ? JSON.parse(resp.isShowFeedbackAndOnlineConsult)
            : resp.isShowFeedbackAndOnlineConsult;
        this.service = resp.item;
        this.$nextTick(()=>{
          console.log((/^(.+[^\/])\/+webapp\//.exec(location.href)[1])+"/WebRoot",'=======================')
          uParse('.panel-intro', {
            rootPath: (/^(.+[^\/])\/+webapp\//.exec(location.href)[1])
          })
        })
        console.log("this.service: ", this.service);
        this.extend = this.service.extends;
        this.arrLength = this.service.service[2].blArr.length;
        this.roleName = resp.roleName;
        this.userId = resp.userId;
        this.showExtends =
          resp.item.extends &&
          resp.item.extends.hasOwnProperty("isOpenExtends") &&
          resp.item.extends.isOpenExtends !== "false";
        this.hasAuth = resp.item.hasAuth;
        var extend = [];
        queryServiceExtends(this.id).then((resp) => {
          this.serviceExtends = resp.data || null;
          if (this.showExtends) {
            this.serviceExtends.extends.forEach((item) => {
              (item.detail.length || item.img) && extend.push(item);
            });
          }
          this.serviceExtends.extends = extend;
          // this.serviceExtends.extends.forEach(item => {
          //     if (item.detail.length > 0) {
          //         item.detail.forEach(item => {
          //             this.flvUrl = item.detail.downloadUrl
          //         })
          //     }
          // })
        });
      })
      .catch((error) => {
        this.mixinPageNetError("请求服务失败");
      })
      .finally(() => {
        // TODO：处理请求完成后结果
        this.mixinClearLoading();
      });
  },
  methods: {
    // init() {
    //     this.play = videojs(
    //         this.$refs["videojs-flvjs-player"],
    //         {
    //             autoplay: false,
    //             controls: true,
    //             preload: "auto",
    //             fluid: true,
    //             sources: [
    //                 {
    //                     src: this.flvUrl,
    //                     type: "video/mp4",
    //                 },
    //             ],
    //         },
    //         () => {
    //             console.log("播放器初始化完成")
    //             this.player.play()

    //             this.player.on("error", err => {
    //                 console.log("first source load fail")

    //                 this.player.src({
    //                     src: this.flvUrl,
    //                     type: "video/mp4",
    //                 })

    //                 this.player.ready(() => {
    //                     this.player.load()
    //                     this.player.play()
    //                 })
    //             })
    //         }
    //     )
    // },

    // 点击地址
    showPopup() {
      let ua = navigator.userAgent.toLowerCase();
      // 企业微信
      if (
        ua.match(/MicroMessenger/i) == "micromessenger" ||
        ua.match(/wxwork/i) == "wxwork"
      ) {
        console.log("changWxMap---");
        this.changWxMap();
      } else {
        // 其他
        this.showPopupFlag = true;
      }
    },
    // 取消选择地图选项
    onCancel() {
      Toast("取消");
    },
    // detectionDevice(act, idx) {
    //   let ua = navigator.userAgent.toLowerCase();
    //   if (
    //     ua.match(/MicroMessenger/i) == "micromessenger" ||
    //     ua.match(/wxwork/i) == "wxwork"
    //   ) {
    //     this.changWxMap(act, idx);
    //   } else if (
    //     ua.match(/welink/i) == "welink" ||
    //     ua.match(/anyoffice/i) == "anyoffice"
    //   ) {
    //     this.changMap(act, idx);
    //   } else if (ua.match(/dingtalk/i) == "dingtalk") {
    //     this.changMap(act, idx);
    //   } else {
    //     this.changMap(act, idx);
    //   }
    // },
    // 微信 选择地图
    changWxMap() {
      console.log("changWxMap-1");
      http
        .get("/weixin/jssdkapi.htm", {
          url: window.location.href.split("#")[0],
        })
        .then((resp) => {
          wx.config({
            debug: false,
            appId: resp.appId,
            timestamp: resp.timestamp,
            nonceStr: resp.nonceStr,
            signature: resp.signature,
            jsApiList: ["checkJsApi", "openLocation"],
          });
        });
      let that = this;
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList: ["openLocation"],
          success: (rest) => {
            // Toast("ready*****",rest);
            console.log("rest", rest);
            //打开指定位置
            wx.openLocation({
              latitude: that.extend.handleAddressJW.lat, // 纬度，浮点数，范围为90 ~ -90
              longitude: that.extend.handleAddressJW.lng, // 经度，浮点数，范围为180 ~ -180。
              name: that.extend.handleAddress, // 位置名
              address: that.extend.handleAddress, // 地址详情说明
              scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
              infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
            });
          },
        });
      });
    },
    // h5 丁丁 选择地图
    changMap(act, idx) {
      console.log("act", act);
      console.log("idx", idx);
      /* Start  判断手机是IOS还是安卓 */
      let u = navigator.userAgent;
      //判断是否安卓
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      // 判断是否IOS
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      switch (act.mapType) {
        // case "qqmap":
        //   this.qqMapFun(act, isAndroid, isIOS);
        //   break;
        case "amap":
          this.aMapFun(act, isAndroid, isIOS);
          break;
        case "baidumap":
          this.baiduMapFun(act, isAndroid, isIOS);
          break;
        default:
          console.log("别瞎几把点");
      }
    },
    // 打开腾讯地图
    // qqMapFun(act, isAndroid, isIOS) {
    //   console.log("qqMapFun", act);
    //   let queryStr = `qqmap://map/routeplan?type=driv&tocoord=${this.StartXY.lat},${this.StartXY.lng}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`;
    //   window.location.href = queryStr;
    // },
    // 打开高德地图
    aMapFun(act, isAndroid, isIOS) {
      console.log("aMapFun", act);
      //判断是否是安卓手机
      let queryStr;
      if (isAndroid) {
        queryStr = `amapuri://route/plan/?sourceApplication=mhc&dlat=${this.extend.handleAddressJW.lat}&dlon=${this.extend.handleAddressJW.lng}&dname=${this.extend.handleAddress}&dev=0&t=0`;
      } else if (isIOS) {
        //IOS手机————高德地图不区分ios和安卓
        queryStr = `iosamap://path?sourceApplication=mhc&dlat=${this.extend.handleAddressJW.lat}&dlon=${this.extend.handleAddressJW.lng}&dname=${this.extend.handleAddress}&dev=0&t=0`;
      }
      window.location.href = queryStr;
    },
    // 打开百度地图
    baiduMapFun(act, isAndroid, isIOS) {
      console.log("baiduMapFun", act);
      let queryStr;
      if (isAndroid) {
        queryStr = `bdapp://map/direction?destination=name:${this.extend.handleAddress}|latlng:${this.extend.handleAddressJW.lat},${this.extend.handleAddressJW.lng}&coord_type=gcj02&mode=driving&src=andr.jianghu.jianhao`;
      } else if (isIOS) {
        queryStr = `baidumap://map/direction?destination=name:${this.extend.handleAddress}|latlng:${this.extend.handleAddressJW.lat},${this.extend.handleAddressJW.lng}&coord_type=gcj02&mode=driving&src=ios.jianghu.jianhao`;
      }
      window.location.href = queryStr;
    },
    handleBtnBoxOpen() {
      if (!this.btnBoxOpen) {
        this.banliBtns.slice(0, this.onlineBtnShowNum);
      } else {
        this.banliBtns.slice(0, this.onlineBtnShowNum);
      }
    },
    getSys() {
      console.log("---------appraiseOn222222222----------");
      console.log(this.appraiseOn);
      let self = this;
      const keys = [
        "onlineBtnShowNum", //部门类别
      ];
      http.get("/param/keys.htm", { keys: keys.join() }).then((resp) => {
        if (!resp || resp.code != 200) {
          Toast({
            message: `获取系统参数${dictionaryKey}失败`,
            className: "zindex",
          });
        } else {
          let data = resp.data;
          this.onlineBtnShowNum = data.onlineBtnShowNum;
        }
      });
    },

    onCollectHandle() {
      if (this.service.isf == "1")
        cancelFavService(this.id).then(() => {
          this.service.isf = "0";
          Toast("取消收藏成功");
        });
      else
        favService(this.id).then(() => {
          this.service.isf = "1";
          Toast("收藏服务成功");
        });
    },
    access() {
      return function (item) {
        // TODO: 判断状态变灰不能点击
        let startDate = this.service.startDate;
        let endDate = this.service.endDate;
        let nowDate = moment().unix() * 1000;
        if (this.service.hasAuth !== "true" || item.visitorFlow === false) {
          return ["无权限", true];
        } else if (!this.service.stats) {
          return ["已停用", true];
        } else if (endDate && endDate !== "" && endDate < nowDate) {
          return ["已停用", true];
        } else if (startDate && startDate !== "" && startDate > nowDate) {
          return ["未启用", true];
        } else {
          return ["进入", false];
        }
      };
    },
    btnClickHandler(blUrl, isDisabled) {
      console.log(this.service, 888);
      !isDisabled &&
        increaseHandle(this.id).finally(() => forward(this.service, blUrl));
    },
    onPreviewFile(fileType, downloadUrl) {
      if (parseFileType(fileType.toLowerCase()) === FILE_TYPE_IMAGE) {
        previewImage([complete(downloadUrl)]);
      } else {
        previewFile(parseFileType(fileType.toLowerCase()), downloadUrl);
      }
    },
    // 2023-10-23 好差评 评价按钮点击事件
    btnRecodeClickHandler() {
      var ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) == "micromessenger" ||
        ua.match(/wxwork/i) == "wxwork"
      ) {
        this.channel = 2;
      } else if (
        ua.match(/welink/i) == "welink" ||
        ua.match(/anyoffice/i) == "anyoffice"
      ) {
        this.channel = 4;
      } else if (ua.match(/dingtalk/i) == "dingtalk") {
        this.channel = 3;
      } else {
        this.channel = 1;
      }
      let serviceId = this.$route.params.id;
      location.href =
        this.appraisePath +
        `/pingjia/h5#/pages/evaluation/evaluation?channel=${this.channel}&stage=0&serviceId=${serviceId}`;
    },
    formatDateTime,
    locationTo,
    complete,
    forward,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme";

#serviceDetail {
  overflow: hidden;
}
.recode-button {
  position: fixed;
  z-index: 9;
  right: 20px;
  bottom: 96px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  border: 2px solid #1989fa;
  box-sizing: border-box;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.2;
  color: #1989fa;
}
.service-container,
.service-info {
  padding: 15px;
  margin: 12px 15px;
  background: #fff;
  border-radius: 5px;
  position: relative;
  img {
    width: 100%;
  }
  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .addressSpan {
    color: #0000ff;
  }

  h4 {
    line-height: 38px;
    margin-right: 35px;
    font-weight: 500;
    color: $c333;
    @extend .font18;
  }

  h6 {
    line-height: 28px;
    font-weight: 500;
    @extend .font13;

    span {
      display: inline-block;
      margin-left: 20px;
    }
    em {
      display: inline-block;
      width: 1.5em;
    }
  }

  p {
    line-height: 27px;
    color: $c333;
    @extend .font14;
  }
  .height-auto {
    height: auto;
    min-height: 100px !important;
    overflow: hidden;
    margin-top: 20px;
    button {
      height: 42px;
      line-height: 42px;
      background: var(--main-color);
      color: #fff;
      border: none;
      border-radius: 5px;
      margin-top: 12px;
      @extend .font16;
      span {
        display: block;
        height: 42px;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:first-child {
        margin-top: 0;
      }
    }

    &.height-auto {
      max-height: inherit !important;
    }
  }
  .service-btn-boxs {
    height: auto;
    overflow: hidden;
    margin-top: 20px;

    button {
      height: 42px;
      line-height: 42px;
      background: var(--main-color);
      color: #fff;
      border: none;
      border-radius: 5px;
      margin-top: 12px;
      @extend .font16;
      span {
        display: block;
        height: 42px;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:first-child {
        margin-top: 0;
      }
    }

    &.height-auto {
      max-height: inherit;
    }
  }

  .service-btn-box {
    height: auto;
    overflow: hidden;
    margin-top: 20px;

    button {
      height: 42px;
      line-height: 42px;
      background: var(--main-color);
      color: #fff;
      border: none;
      border-radius: 5px;
      margin-top: 12px;
      @extend .font16;
      span {
        display: block;
        height: 42px;
        line-height: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:first-child {
        margin-top: 0;
      }
    }

    &.height-auto {
      max-height: inherit;
    }
  }
  .none {
    display: none;
  }

  .toggle-icon {
    width: 45px;
    height: 18px;
    margin: 0 auto;
    position: relative;

    .iconfont {
      font-size: 18px;
      position: absolute;
      left: 50%;
      top: 0;
      margin-left: -9px;
      transform: rotate(90deg);
      color: var(--main-color);
    }

    &.close .iconfont {
      transform: rotate(-90deg);
    }
  }

  .collect {
    display: flex;
    align-content: center;
    text-align: center;
    justify-content: center;
    width: 35px;
    height: 50px;
    background: #f5b86f;
    position: absolute;
    top: 0;
    right: 15px;
    padding-top: 10px;
    box-sizing: border-box;
    .iconfont {
      font-size: 22px;
      color: #fff;
    }

    &:after {
      content: "";
      display: block;
      border-left: 18px solid transparent;
      border-right: 18px solid transparent;
      border-top: 10px solid transparent;
      border-bottom: 10px solid #fff;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .about-dept {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    p {
      display: flex;
      min-height: 30px;
      line-height: 30px;
      @extend .font14;
      label {
        white-space: nowrap;
      }
    }
  }
  .panel-intro {
    color: #999;
    text-align: justify;
    line-height: 1.5;
    margin-bottom: 20px;
    padding: 0 15px;

    @extend .font13;
  }
}
.download-link {
  color: #1678ff;
}

.detail-tabbar {
  height: 50px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: content-box;
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;

  .tabbar-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    color: #646566;
    line-height: 1;
    cursor: pointer;
    @extend .font12;
    .icon-box {
      text-align: center;
      .iconfont {
        font-size: $base-fontsize24;
      }
    }
    span {
      @extend .font14;
    }
  }
}
.empty {
  margin-top: 100px;
}

</style>
<style>
.list-paddingleft-1 li{
  list-style-type: none;
}
.panel-intro img{
  max-width: 100% !important;
}
</style>
